/**
 * assets/cats.js
 * QuickSignage — Single source of truth for all category data.
 * Loaded by featured-categories.liquid (hub grid) and
 * page.collections.liquid (single category page via ?category=KEY).
 */
window.QS = window.QS || {};

window.QS.ICONS = {
  check: '<polyline points="20 6 9 17 4 12"/>',
  clock:
    '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
  shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
  star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
  users:
    '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  globe:
    '<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>',
  home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>',
  image:
    '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>',
  zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>',
  tool: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>',
  map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/>',
  file: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>',
  repeat:
    '<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>',
  layers:
    '<polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>',
  sun: '<circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>',
};

window.QS.STARS = Array(5)
  .fill(
    '<svg viewBox="0 0 24 24" style="width:14px;height:14px;fill:var(--nt-star);stroke:var(--nt-star);stroke-width:1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
  )
  .join("");

window.QS.CATS = {
  exterior: {
    label: "Outdoor Signs / Exterior Signage",
    h1: "Outdoor Signs",
    h1em: "Exterior Signage",
    img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-Backlit-Channel-Letter-Sign-3-D-Logo-Sign-Outdoor-Business-Wall-Sign-Illuminated-Storefront.jpg?v=1790587446",
    alt: "Lit outdoor business signs, exterior business signs and large outdoor signs for business - quicksignage.com",
    desc: "Shop outdoor business signs and exterior building signage made to your logo, from outdoor lighted signs for business to non lit exterior signs. Every sign is fabricated in-house, factory-direct, and shipped to all 50 states.",
    pills: ["Weather rated exterior signs", "City permit support", "Day & night visibility"],
    compareHead: "All 8 outdoor business signs at a glance",
    compare: [
      {
        name: "Outdoor Backlit Signs",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Lightbox Sign",
        vis: 5,
        lighting: "lit",
        dur: 5,
        cost: "$$$",
      },
      {
        name: "Push-Through Sign",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Lighted signs for business",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Front-Lit Letters on Backboard / Wireway",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Metal Backlit Letters on Backboard / Raceway",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Commercial business signs",
        vis: 3,
        lighting: "nonlit",
        dur: 4,
        cost: "$$",
      },
      {
        name: "3D signs",
        vis: 4,
        lighting: "opt",
        dur: 4,
        cost: "$$$",
      },
    ],
    whys: [
      {
        icon: "shield",
        h: "UL-Listed Components",
        s: "Meets US electrical codes",
      },
      {
        icon: "globe",
        h: "All 50 States",
        s: "Installation network nationwide",
      },
      {
        icon: "home",
        h: "Landlord Approval Docs",
        s: "We prepare the paperwork",
      },
      {
        icon: "image",
        h: "Free Mockup on Building",
        s: "See it on your wall first",
      },
    ],
    sectionLabel: "8 Sign Types · Outdoor Signs / Exterior Signage",
    sectionH: "Choose Your",
    sectionHem: "Outdoor Sign",
    sectionSub: "8 types of outdoor signage for business, lit and non lit. Use the comparison table to find the right exterior business sign fast.",
    installs: [
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1a8bfc475f04e41dc4168ddc673f5e30.jpg?v=1773827971",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/a41f50aee39a3c269c600156808215e7.jpg?v=1773827697",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_3__LE_auto_x2_1_optimized_2aab19f0-be86-4872-b5b0-004bc6f278dd.webp?v=1748083042",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/b6d42cc645663d276ce14ed30556dca0.jpg?v=1773827847",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d_halo_lit_sign.webp?v=1726726381",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/2d85a2a2fc7666b85ef8c76c8d30591a.jpg?v=1774339718",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/printed_sign_with_halo_lit_backboard_LE_ml_resize_custom.jpg?v=1726056610",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1164690c75c91f2fa591ac6e1af532d9.jpg?v=1773827490",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_3__LE_auto_x2_1_optimized_2aab19f0-be86-4872-b5b0-004bc6f278dd.webp?v=1748083042",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/hollow_cut_backlit.webp?v=1726726381",
    ],
    signs: [
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-Metal-Backlit-LED-Sign-3-D-Business-Signage-Storefront-Sign-Metal-Backlit-Sign-Sign-For-Of.jpg?v=1790587620",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Outdoor Backlit Signs",
        desc: "Halo lit metal letters, top outdoor lighted signs for business and exterior business signs, with business signs outdoor lighted from behind.",
        tags: ["Metal", "Backlit", "Exterior"],
        alt: "Halo lit metal letters, outdoor backlit signs and outdoor lighted signs for business - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Luxury-Square-Sign-Illuminated-Hanging-Business-Sign-Double-Sided-LED-Light-Box-Modern-Storefront.jpg?v=1790587524",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Lightbox Sign",
        desc: "Single or double sided cabinets, large outdoor signs for business that work as an exterior sign for business, roadside outdoor signage for business or lighted signs for business.",
        tags: ["Lightbox", "Single/Double Sided", "Lit"],
        alt: "Single and double sided lightbox sign, large outdoor signs for business and light box signs outdoor - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-May-11-2026-04-24-08-PM-1.png?v=1790587866",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Push-Through Sign",
        desc: "Letters pushed through an aluminum face for high contrast exterior building signage, custom exterior signs that read as an exterior business sign at night.",
        tags: ["Push Through", "Lit", "Exterior"],
        alt: "Lit push through acrylic sign, custom exterior signs and exterior building signage - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Mar-19-2026-12-52-56-PM-1.png?v=1790587963",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Lighted signs for business",
        desc: "Looking for custom business signs outdoors? These lit outdoor business signs are custom outdoor signs for business, visible day and night.",
        tags: ["Lighted", "Business", "Exterior"],
        alt: "Illuminated lighted signs for business, custom business signs outdoor and business signs outdoor lighted - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-Storefront-Signage.jpg?v=1790588010",
        _imgLocked: true,
        gallery: [
          "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-Storefront-Signage.jpg?v=1790588010",
          "https://i.ibb.co/zWFkVS18/image-45-1-3.png",
        ],
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Front-Lit Letters on Backboard / Wireway",
        desc: "Front lit letters on a backboard or wireway, an outdoor business sign that installs as one exterior building sign. Ideal business outdoor signs for uneven walls.",
        tags: ["Front Lit", "Backboard", "Wireway"],
        alt: "Front lit letters on a wireway, outdoor business sign and exterior building sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/image-45-1-3_a0ab6b42-3766-4063-9ed5-80430c83f24f.png?v=1790588153",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Metal Backlit Letters on Backboard / Raceway",
        desc: "Backlit metal letters on a backboard or raceway, popular exterior building signs and outdoor business signs for buildings with strict landlords.",
        tags: ["Metal", "Backlit", "Raceway"],
        alt: "Backlit metal letters on a raceway, exterior building signs and outdoor business signs for buildings - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Scootaround_LED_Channel_Letters_Winnipeg.jpg?v=1790668089",
        _imgLocked: true,
        badge: "badge-outdoor",
        badgeTxt: "Exterior",
        name: "Commercial business signs",
        desc: "Non lit exterior signs and signs for business outdoor use, from exterior commercial signs to exterior commercial signage for office parks.",
        tags: ["Commercial", "Business", "Exterior"],
        alt: "Non lit commercial business signs, exterior commercial signs and signs for business outdoor - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/download-45.jpg?v=1790588285",
        _imgLocked: true,
        badge: "badge-outdoor",
        badgeTxt: "Exterior",
        name: "3D signs",
        desc: "Lit or non lit 3D letters that add depth to exterior signage, made as signs for buildings exterior walls and outdoor building signs for business.",
        tags: ["3D", "Dimensional", "Exterior"],
        alt: "Dimensional 3d signs, outdoor building signs for business and exterior signage - quicksignage.com",
      },
    ],
    testi: [
      {
        init: "MR",
        name: "Marcus R.",
        biz: "Owner, Riverfront Grill — Austin, TX",
        quote: "The halo-lit letters on our facade look <strong>incredible at night</strong>. The mockup matched the final product perfectly. Zero surprises.",
      },
      {
        init: "DT",
        name: "David T.",
        biz: "Facilities Dir., Forge Fitness — Multiple Locations",
        quote: "We've done three locations now. <strong>Consistent quality every time</strong>, and the permit coordination saves us weeks per project.",
      },
    ],
    ctaH: "See It on Your",
    ctaHem: "Building First.",
    ctaSub: "Send your logo and address. We'll place your exterior business sign on a photo of your actual building, free, in 2 hours.",
    ctaBtn: "Get Free Mockup on My Building",
  },
  lobby: {
    label: "Illuminated Channel Letters / Raceway Signage",
    h1: "Illuminated Channel Letters",
    h1em: "Raceway Signage",
    img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Chat-GPT-Image-Sep-25-2026-04-57-24-PM.png?v=1790756268",
    alt: "Bright illuminated channel letters on a raceway, channel letters signs and halo lit channel letters - quicksignage.com",
    desc: "Shop channel letters and illuminated signage in every style, from front lit channel letters to halo lit channel letters and reverse channel letters. Mounted direct or on a raceway, every piece is fabricated in-house and shipped to all 50 states.",
    pills: ["Front lit & backlit options", "Raceway or direct mount", "Indoor & outdoor use"],
    compareHead: "All 6 channel letters signs at a glance",
    compare: [
      {
        name: "Backlit channel letters",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$$",
      },
      {
        name: "Front lit channel letters",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Channel letters with raceway",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "3D business signs",
        vis: 4,
        lighting: "opt",
        dur: 5,
        cost: "$$",
      },
      {
        name: "LED storefront signs",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Aluminium letters signs",
        vis: 3,
        lighting: "nonlit",
        dur: 5,
        cost: "$$",
      },
    ],
    whys: [
      {
        icon: "check",
        h: "No Drilling Option",
        s: "Adhesive mount available",
      },
      {
        icon: "clock",
        h: "2-Week Turnaround",
        s: "From approval to delivery",
      },
      {
        icon: "star",
        h: "Premium Finishes",
        s: "Brushed, gloss, matte",
      },
      {
        icon: "users",
        h: "Corporate & Medical",
        s: "Most common client types",
      },
    ],
    sectionLabel: "6 Sign Types · Illuminated Channel Letters / Raceway Signage",
    sectionH: "Choose Your",
    sectionHem: "Channel Letters",
    sectionSub: "6 types of channel letters signs and illuminated business signs. Compare lighting, visibility and cost below.",
    installs: [
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_flat_cut.webp?v=1726053397",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_letters_LE_ml_resize_custom.jpg?v=1726056610",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Adhesive_Acrylic_Wall_Sign.webp?v=1726728662",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_and_backli_-_Copy.jpg?v=1762602617",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Adhesive_Metal_Wall_Sign.jpg?v=1726728662",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1a8bfc475f04e41dc4168ddc673f5e30.jpg?v=1773827971",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/a41f50aee39a3c269c600156808215e7.jpg?v=1773827697",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/9c223b362d28070015feea9c3f4d2136_166bddae-60ef-4869-b0ec-f70e6663c7f4.jpg?v=1762509285",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/printed_sign.webp?v=1726726381",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/b6d42cc645663d276ce14ed30556dca0.jpg?v=1773827847",
    ],
    signs: [
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/download-84_b3bd9929-36bb-43e7-b8cb-36b8f2195c5d.jpg?v=1790674215",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Backlit channel letters",
        place: "interior",
        desc: "Also called halo lit channel letters or reverse channel letters, backlit channel letters cast a soft glow on the wall behind them.",
        tags: ["3D", "Metal", "Backlit"],
        alt: "3D metal backlit channel letters, halo lit channel letters and reverse channel letters - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Led-Channel-Letters-With-Front-Back-Lit-Led-Logo-Signs.jpg?v=1790674025",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Front lit channel letters",
        place: "interior",
        desc: "The classic front lit channel letters look. These illuminated channel letters make a bright, readable channel letters sign.",
        tags: ["Front Lit", "Channel Letters", "Illuminated"],
        alt: "Bright front lit channel letters, illuminated channel letters and channel letters sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Screenshot-32.png?v=1790591502",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Channel letters with raceway",
        place: "interior",
        desc: "Our channel letters mount on a raceway for easier channel letters signage installs. We build custom channel letters and full channel letters signs.",
        tags: ["Channel Letters", "Raceway", "Exterior"],
        alt: "Acrylic front lit channel letters on a raceway, channel letters signage and custom channel letters - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/download-57.png?v=1790674133",
        _imgLocked: true,
        badge: "badge-interior",
        badgeTxt: "Interior",
        name: "3D business signs",
        place: "interior",
        desc: "3D letters as illuminated business signs or non lit pieces. Pick custom illuminated signs for illuminated signage that stands out after dark.",
        tags: ["3D", "Business", "Lit / Non-Lit"],
        alt: "Dimensional 3d business signs as illuminated business signs and custom illuminated signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/2bd08902e82c9ecdd959cf2e93586b42.jpg?v=1790591562",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "LED storefront signs",
        place: "interior",
        desc: "Edge lit panels, one of our slimmest business led signs. Like all our led business signs, each illuminated sign is made to your logo.",
        tags: ["LED", "Illuminated", "Edge Lit"],
        alt: "Edge lit led storefront signs, business led signs and led business signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/image_14b82e9f-e6fa-4560-9ba3-bd6f3a1a9d0e.jpg?v=1790674290",
        _imgLocked: true,
        badge: "badge-interior",
        badgeTxt: "Interior",
        name: "Aluminium letters signs",
        place: "interior",
        desc: "Flat cut aluminium letters that pair with illuminated signs, a simple match for illuminated signs for businesses mixing lit and non lit pieces.",
        tags: ["Aluminium", "Metal", "Flat Cut"],
        alt: "Edge lit led storefront signs, business led signs and led business signs - quicksignage.com",
      },
    ],
    testi: [
      {
        init: "SL",
        name: "Sarah L.",
        biz: "Office Manager, Crestline Partners — Denver, CO",
        quote: "The 3D acrylic letters look <strong>seriously high-end</strong>. Our clients ask about them every single week.",
      },
      {
        init: "KN",
        name: "Dr. Karen N.",
        biz: "NorthStar Family Medicine — Phoenix, AZ",
        quote: "Clean, professional, and went up without a single hole in the drywall. <strong>Exactly what a medical office needs.</strong>",
      },
    ],
    ctaH: "Ready to Light Up",
    ctaHem: "Your Brand?",
    ctaSub: "Share your logo and wall dimensions. We'll mock up your channel letters sign at scale so you know exactly how it looks before you commit.",
    ctaBtn: "Get Free Mockup",
  },
  salon: {
    label: "Face Lit Signage / Front Lit Signs",
    h1: "Face Lit Signage",
    h1em: "Front Lit Signs",
    img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-Frontlit-Channel-Letters-LED-Storefront-Sign-for-Restaurant-Cafe-Bakery-Retail.jpg?v=1790590296",
    alt: "Bright face lit letters, front lit channel letters and lighted business signs - quicksignage.com",
    desc: "Front lit and face lit letters put light right on your logo, so your name reads clearly from the street and across a room. Choose a front lit sign, face lit sign, double lit or all lit style, fabricated in-house in acrylic and metal.",
    pills: ["Bright, even face lighting", "Custom shapes welcome", "Indoor & outdoor solutions"],
    compareHead: "All 6 front lit signs at a glance",
    compare: [
      {
        name: "Front lit channel letters",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Front Lit Channel Letters on Raceway",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "3D facelit Signage",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Front Lit Letters on Backboard",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "All Lit Sign",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$$",
      },
      {
        name: "Front Lit & Backlit (Double Lit) Signs",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$$",
      },
    ],
    whys: [
      {
        icon: "star",
        h: "Social-Ready Look",
        s: "Guests photograph it for you",
      },
      {
        icon: "zap",
        h: "Dimmer Included",
        s: "Control mood at any hour",
      },
      {
        icon: "shield",
        h: "No Glass Breakage",
        s: "Safe in high-traffic spaces",
      },
      {
        icon: "check",
        h: "Custom Shapes & Text",
        s: "Script, logo, or icon — any format",
      },
    ],
    sectionLabel: "6 Sign Types · Face Lit Signage / Front Lit Signs",
    sectionH: "Choose Your",
    sectionHem: "Front Lit Sign",
    sectionSub: "6 types of lighted signs with an illuminated face. Pick by mounting, brightness and budget.",
    installs: [
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/Sign_Home_Banners_3_1.webp?v=1733208367",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/Sign_Home_Banners_4_1.webp?v=1733208207",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d_halo_lit_sign.webp?v=1726726381",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/44.webp?v=1716796813",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/9c223b362d28070015feea9c3f4d2136_166bddae-60ef-4869-b0ec-f70e6663c7f4.jpg?v=1762509285",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1a8bfc475f04e41dc4168ddc673f5e30.jpg?v=1773827971",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_letters_LE_ml_resize_custom.jpg?v=1726056610",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_3__LE_auto_x2_1_optimized_2aab19f0-be86-4872-b5b0-004bc6f278dd.webp?v=1748083042",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/a41f50aee39a3c269c600156808215e7.jpg?v=1773827697",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/hollow_cut_backlit.webp?v=1726726381",
    ],
    signs: [
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-03-05-17-PM.png?v=1790590341",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Front Lit",
        name: "Front lit channel letters",
        place: "both",
        desc: "Front lit acrylic letters with a bright face, also called face lit letters. A front lit sign that reads clearly day and night.",
        tags: ["Front Lit", "3D Acrylic", "Channel Letters"],
        alt: "Acrylic front lit channel letters, face lit letters and front lit sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-03-59-31-PM.png?v=1790590389",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Front Lit",
        name: "Front Lit Channel Letters on Raceway",
        place: "both",
        desc: "Front lit channel letters on a raceway. Practical lighted signs for exterior walls, lighted business signs and outdoor led signs for business.",
        tags: ["Front Lit", "Raceway", "Channel Letters"],
        alt: "Front lit channel letters on a raceway, lighted business signs and outdoor led signs for business - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Thomas-Design-Builders-Ltd-LED-Face-lit-Halo-lit-Letters.jpg?v=1790590414",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Front Lit",
        name: "3D facelit Signage",
        place: "both",
        desc: "Dimensional acrylic 3d letters with a glowing face. Our custom 3d acrylic signs come in any color, and our 3d acrylic signs work as a face lit sign or non lit.",
        tags: ["3D Acrylic", "Face Lit", "Illuminated"],
        alt: "Face lit 3d acrylic signs, custom 3d acrylic signs and acrylic 3d letters - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Chat-GPT-Image-Sep-25-2026-04-04-26-PM.png?v=1790673183",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Front Lit",
        name: "Front Lit Letters on Backboard",
        place: "both",
        desc: "A lighted sign on a backboard hides wiring and old holes, an easy lighted sign for business and a clean 3d acrylic sign upgrade.",
        tags: ["Front Lit", "Backboard", "3D Acrylic"],
        alt: "Front lit letters on a backboard, lighted sign for business and 3d acrylic sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Full-Lit-3-D-Acrylic-Letter-Sign.jpg?v=1790590500",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "All Lit",
        name: "All Lit Sign",
        place: "both",
        desc: "Fully illuminated sign with front and back lighting, lighted signage with maximum glow, built for led signs for business outdoor and business led signs outdoor.",
        tags: ["All Lit", "Illuminated", "3D Acrylic"],
        alt: "All lit 3D acrylic sign, lighted signage and led signs for business outdoor - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/c989f820-b9df-418e-a41f-6194da00eee3.png?v=1790590547",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Double Lit",
        name: "Front Lit & Backlit (Double Lit) Signs",
        place: "both",
        desc: "Front lit and backlit sign in one. The face glows while the backlit acrylic sign layer throws a halo on the wall.",
        tags: ["Double Lit", "Front Lit", "Backlit"],
        alt: "Double lit front lit and backlit acrylic sign, lighted signs and business led signs outdoor - quicksignage.com",
      },
    ],
    testi: [
      {
        init: "AP",
        name: "Anita P.",
        biz: "Co-owner, Wildflower Salon — Portland, OR",
        quote: "The neon sign behind our wash station is <strong>tagged on Instagram every single day</strong>. It's become our brand.",
      },
      {
        init: "CL",
        name: "Chris L.",
        biz: "Owner, Iron Circuit Gym — Chicago, IL",
        quote: "Backlit metal letters outside, neon wall inside. <strong>Both were perfect on first delivery</strong> — not a single revision needed.",
      },
    ],
    ctaH: "See It",
    ctaHem: "Lit Up First.",
    ctaSub: "Share your logo and the wall it's going on. We'll mock up your face lit sign so you can see it before you order.",
    ctaBtn: "Get Free Mockup",
  },
  storefront: {
    label: "Storefront Signs / Outdoor Building Signage",
    h1: "Storefront Signs",
    h1em: "Outdoor Building Signage",
    img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-3-D-Metal-Backlit-Business-Logo-Sign-Illuminated-Storefront-Signage-Laser-Cut-Stainless-Stee.jpg?v=1790588353",
    alt: "Illuminated storefront signs, storefront signage and store front signs for business - quicksignage.com",
    desc: "A storefront sign works every minute your doors are closed. We are the store front sign maker businesses across all 50 states rely on for storefront signs, storefront signage and building signs, all fabricated in-house. These are the sign types retail businesses order most.",
    pills: ["Day & night visibility", "Weather-rated materials", "City permit support"],
    compareHead: "All 12 storefront signs at a glance",
    compare: [
      {
        name: "Front lit channel letters",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "3D Metal Backlit, Halo-Lit Letters",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Wall Mounted Lightbox",
        vis: 4,
        lighting: "lit",
        dur: 5,
        cost: "$$",
      },
      {
        name: "3D metal signs",
        vis: 4,
        lighting: "nonlit",
        dur: 5,
        cost: "$$",
      },
      {
        name: "Push Through Sign",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "LED storefront signs",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "3D Backlit on Backboard / Raceway",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "3D Face lit on Backboard / Raceway",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Custom Fabricated 3D Sign",
        vis: 4,
        lighting: "nonlit",
        dur: 5,
        cost: "$$$",
      },
      {
        name: "3D Non-Lit Letters on Backboard",
        vis: 4,
        lighting: "nonlit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Hollow Cut Sign",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "3D signs for business",
        vis: 4,
        lighting: "opt",
        dur: 4,
        cost: "$$$",
      },
    ],
    whys: [
      {
        icon: "sun",
        h: "24/7 Visibility",
        s: "Works in daylight and at night",
      },
      {
        icon: "globe",
        h: "All 50 States",
        s: "Nationwide installation network",
      },
      {
        icon: "home",
        h: "Permit Support",
        s: "We prepare city paperwork",
      },
      {
        icon: "image",
        h: "Free Facade Mockup",
        s: "See it on your storefront first",
      },
    ],
    sectionLabel: "12 Sign Types · Storefront Signs / Outdoor Building Signage",
    sectionH: "Choose Your",
    sectionHem: "Storefront Sign",
    sectionSub: "12 types of storefront signs for business. Pick by budget and street conditions, from a quiet block to a busy pedestrian row.",
    installs: [
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_3__LE_auto_x2_1_optimized_2aab19f0-be86-4872-b5b0-004bc6f278dd.webp?v=1748083042",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1a8bfc475f04e41dc4168ddc673f5e30.jpg?v=1773827971",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/a41f50aee39a3c269c600156808215e7.jpg?v=1773827697",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/bladesign_4.jpg?v=1705923789",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/wall_mounted_lightbox_LE_ml_resize_custom.jpg?v=1726053663",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/hollow_cut_backlit.webp?v=1726726381",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/b6d42cc645663d276ce14ed30556dca0.jpg?v=1773827847",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/2d85a2a2fc7666b85ef8c76c8d30591a.jpg?v=1774339718",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d_halo_lit_sign.webp?v=1726726381",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/printed_sign_with_halo_lit_backboard_LE_ml_resize_custom.jpg?v=1726056610",
    ],
    signs: [
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Custom-3-D-LED-Channel-Letters-Sign-Outdoor-Business-Signage-Trimless-Plexiglass-Letters-Illumi.jpg?v=1790670121",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Front lit channel letters",
        place: "exterior",
        desc: "Front lit acrylic channel letters, cost effective storefront signs with storefront letters that keep store front signs readable from the street.",
        tags: ["Front Lit", "Channel Letters", "Exterior"],
        alt: "Acrylic front lit channel letters, storefront signs and store front signs for business - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Metal-Backlit-Sign-3-D-Business-Signboard-Boutique-Sign-Metal-Letter-For-Wall-3-D-Logo-Sign-Halo.jpg?v=1790588430",
        _imgLocked: true,
        badge: "badge-popular",
        badgeTxt: "Best Seller",
        name: "3D Metal Backlit, Halo-Lit Letters",
        place: "exterior",
        desc: "Halo lit metal letters, a top choice in storefront signage. We build custom storefront signs that glow at night, also used as building signs on offices.",
        tags: ["Channel Letters", "Halo Lit", "Exterior"],
        alt: "3D metal halo lit channel letters, storefront signage and custom storefront signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/download-81.jpg?v=1790588475",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Storefront",
        name: "Wall Mounted Lightbox",
        place: "exterior",
        desc: "Wall mounted illuminated cabinet built to your size, the workhorse of storefront light box signs. A bright lighted store sign and one of the most common signs for store fronts.",
        tags: ["Lightbox", "Wall Mount", "Retail"],
        alt: "Single sided wall mounted lightbox, storefront light box signs and lighted store sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/0-1.jpg?v=1790588508",
        _imgLocked: true,
        badge: "badge-outdoor",
        badgeTxt: "Exterior",
        name: "3D metal signs",
        place: "exterior",
        desc: "Dimensional metal letters for premium building signage. As a store front sign maker, we cut each custom building sign to your logo.",
        tags: ["3D", "Metal", "Storefront"],
        alt: "Dimensional 3d metal signs, building signs and custom building sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Chat-GPT-Image-May-11-2026-04-28-50-PM-1.png?v=1790670265",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Illuminated",
        name: "Push Through Sign",
        place: "exterior",
        desc: "Only the letters glow, a sharp sign for store front walls and one of the highest contrast store front signs for business at night.",
        tags: ["Push Through", "Night Visibility", "Retail"],
        alt: "Push through sign with glowing letters, store front sign and storefront signs for business - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/download-90.jpg?v=1790670523",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Storefront",
        name: "LED storefront signs",
        place: "exterior",
        desc: "Edge lit acrylic panels, a slim led store front sign. Our led signs for business stay bright, and every led business sign is made to your logo.",
        tags: ["LED", "Illuminated", "Storefront"],
        alt: "Edge lit led store front sign, led signs for business and led business sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/image-45-1-3_ee8c0698-7cab-4946-a778-fa271979274f.png?v=1790588644",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "3D Backlit on Backboard / Raceway",
        place: "exterior",
        desc: "Backlit metal letters on a backboard or raceway, common for outdoor storefront signs and building signs for business in shopping centers.",
        tags: ["Backboard", "Raceway", "Backlit"],
        alt: "3D backlit letters on a backboard, outdoor storefront signs and building signs for business - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/fitness-insights.webp?v=1790588676",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "3D Face lit on Backboard / Raceway",
        place: "exterior",
        desc: "Face lit letters on a backboard or raceway, a store front sign style for commercial storefront signs in malls and business storefront signs.",
        tags: ["Face Lit", "Backboard", "Raceway"],
        alt: "3D face lit letters on a backboard, commercial storefront signs and storefront business signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/A-logo-that-speaks-your-brand-Designed-by-Brandbu-creatives-Need-one-Let-s-build-your-identity.jpg?v=1790668294",
        _imgLocked: true,
        badge: "badge-outdoor",
        badgeTxt: "Non-Lit",
        name: "Custom Fabricated 3D Sign",
        place: "exterior",
        desc: "Premium non lit metal letters for one custom storefront sign, a custom store front sign for a new location, or building business signs.",
        tags: ["3D", "Custom Fabricated", "Non-Lit"],
        alt: "Custom fabricated 3D non lit metal letters, custom storefront sign and building business signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Custom-Backlit-Business-Logo-Sign-Wood-Metal-Panel-Etsy.jpg?v=1790668615",
        _imgLocked: true,
        badge: "badge-outdoor",
        badgeTxt: "Non-Lit",
        name: "3D Non-Lit Letters on Backboard",
        place: "exterior",
        desc: "Non lit letters on a backboard for daytime outdoor building signage, a simple sign for building entrances and signs for store front walls.",
        tags: ["3D", "Non-Lit", "Backboard"],
        alt: "3D non lit letters on a backboard, outdoor building signage and sign for building - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/download-91.jpg?v=1790668697",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Hollow Cut Sign",
        place: "exterior",
        desc: "Letters that float in light. These illuminated signage letters stand out among storefront business signs and outdoor illuminated signs at night.",
        tags: ["Hollow Cut", "Illuminated", "Modern"],
        alt: "Hollow cut sign with illuminated signage letters and outdoor illuminated signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-03-04-05-PM.png?v=1790589069",
        _imgLocked: true,
        badge: "badge-outdoor",
        badgeTxt: "Exterior",
        name: "3D signs for business",
        place: "exterior",
        desc: "Dimensional 3D letters and logos, flexible storefront signs for business for retail units and offices.",
        tags: ["3D", "Business", "Storefront"],
        alt: "Dimensional 3d signs for business, storefront letters and building signage - quicksignage.com",
      },
    ],
    testi: [
      {
        init: "JK",
        name: "Jamie K.",
        biz: "Owner, Juniper Boutique — Nashville, TN",
        quote: "The halo-lit letters look incredible at night. <strong>Foot traffic is noticeably up</strong> since they went up.",
      },
      {
        init: "TP",
        name: "Tara P.",
        biz: "Store Manager, Bloom Apparel — Miami, FL",
        quote: "We swap the lightbox graphic every season. <strong>No reinstall cost, no permits</strong> — just pull the face and slide in the new print.",
      },
    ],
    ctaH: "See It on Your",
    ctaHem: "Storefront First.",
    ctaSub: "Send us your logo and address. We place your store front sign on a photo of your actual facade, free, in 2 hours.",
    ctaBtn: "Get Free Facade Mockup",
  },
  restaurant: {
    label: "Corporate & Restaurant Signs / Commercial Signage",
    h1: "Corporate & Restaurant Signs",
    h1em: "Commercial Signage",
    img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-04-45-18-PM.png?v=1790589637",
    alt: "Backlit corporate signage, commercial signage and commercial business signs - quicksignage.com",
    desc: "Restaurants, hotels and offices run on first impressions. Your exterior sign is the handshake before a guest or client walks in. These are the corporate signs and commercial business signs hospitality and office brands order most.",
    pills: ["Restaurant exterior signage", "Corporate office branding", "Works in all restaurant formats"],
    compareHead: "All 6 commercial business signs at a glance",
    compare: [
      {
        name: "Corporate Face Lit Sign",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Backlit Metal Signs",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Custom lightbox sign",
        vis: 5,
        lighting: "lit",
        dur: 5,
        cost: "$$$",
      },
      {
        name: "3D Non-Illuminated Letters",
        vis: 3,
        lighting: "nonlit",
        dur: 5,
        cost: "$$$",
      },
      {
        name: "Commercial business signs",
        vis: 3,
        lighting: "nonlit",
        dur: 4,
        cost: "$$",
      },
      {
        name: "Illuminated channel letters",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
    ],
    whys: [
      {
        icon: "star",
        h: "Social Media Moments",
        s: "Neon walls guests photograph",
      },
      {
        icon: "sun",
        h: "Day & Night Impact",
        s: "Backlit signs work 24/7",
      },
      {
        icon: "globe",
        h: "All 50 States",
        s: "Installation network nationwide",
      },
      {
        icon: "image",
        h: "Free Mockup",
        s: "On your facade or interior wall",
      },
    ],
    sectionLabel: "6 Sign Types · Corporate & Restaurant Signs / Commercial Signage",
    sectionH: "Choose Your",
    sectionHem: "Commercial Sign",
    sectionSub: "6 types of commercial signs for business. Exterior signs bring guests in, and interior branding keeps your name in front of them.",
    installs: [
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/Sign_Home_Banners_4_1.webp?v=1733208207",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/Sign_Home_Banners_3_1.webp?v=1733208367",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/bladesign_4.jpg?v=1705923789",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_3__LE_auto_x2_1_optimized_2aab19f0-be86-4872-b5b0-004bc6f278dd.webp?v=1748083042",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/lightbox_4.webp?v=1733208131",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/44.webp?v=1716796813",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1a8bfc475f04e41dc4168ddc673f5e30.jpg?v=1773827971",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/3d_halo_lit_sign.webp?v=1726726381",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/a41f50aee39a3c269c600156808215e7.jpg?v=1773827697",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/b6d42cc645663d276ce14ed30556dca0.jpg?v=1773827847",
    ],
    signs: [
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/GRECO.jpg?v=1790589746",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Corporate Face Lit Sign",
        place: "exterior",
        desc: "Front lit acrylic letters priced below metal, a smart corporate sign and a staple of corporate signage and commercial retail signs.",
        tags: ["Front Lit", "3D Acrylic", "Budget-Friendly"],
        alt: "3D acrylic front lit corporate sign, corporate signage and commercial retail signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/m-s-1_80e6ec62-75fe-48bc-b3ec-584fa4b8c520.jpg?v=1790589773",
        _imgLocked: true,
        badge: "badge-popular",
        badgeTxt: "Exterior",
        name: "Backlit Metal Signs",
        place: "exterior",
        desc: "Halo lit metal letters, the standard in corporate office signage, working day and night as corporate signs or upscale commercial signage.",
        tags: ["Channel Letters", "Halo Lit", "Exterior"],
        alt: "Halo lit backlit metal sign, corporate office signage and commercial signage - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-03-32-49-PM_64d5c3bf-2670-4787-aa61-f2edbdfea255.png?v=1790589850",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Custom lightbox sign",
        place: "exterior",
        desc: "Double sided lightbox seen from both directions, a commercial sign indoors or an outdoor commercial sign at entrances.",
        tags: ["Double Sided", "Lightbox", "Entrance"],
        alt: "Double sided lightbox, commercial sign and outdoor commercial sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/BLEUSALT-OUTDOOR-PIN-MOUNTED-CHANNEL-LETTERS.jpg?v=1790589878",
        _imgLocked: true,
        badge: "badge-outdoor",
        badgeTxt: "Non-Lit",
        name: "3D Non-Illuminated Letters",
        place: "exterior",
        desc: "Non lit 3D letters for restaurant exteriors, corporate office signs and commercial building signs.",
        tags: ["3D", "Non-Lit", "Exterior"],
        alt: "3D metal non lit letters, corporate office signs and commercial building signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Boutique-Hotel-in-Kansas-City-Hotel-Indigo-Hotel-Indigo-Kansas-City-Downtown.jpg?v=1790589910",
        _imgLocked: true,
        badge: "badge-outdoor",
        badgeTxt: "Exterior",
        name: "Commercial business signs",
        place: "exterior",
        desc: "General commercial business signs, from commercial outdoor signs on the facade to commercial signs for business interiors.",
        tags: ["Commercial", "Business", "Exterior"],
        alt: "Custom commercial business signs, commercial signs for business and commercial outdoor signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Scootaround-LED-Channel-Letters-Winnipeg.jpg?v=1790589982",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Illuminated channel letters",
        place: "exterior",
        desc: "Bright illuminated channel letters for restaurants and hotels, a staple of exterior commercial signage.",
        tags: ["Channel Letters", "Illuminated", "Exterior"],
        alt: "Bright illuminated channel letters, exterior commercial signage and corporate signs - quicksignage.com",
      },
    ],
    testi: [
      {
        init: "MR",
        name: "Marcus R.",
        biz: "Owner, Riverfront Grill — Austin, TX",
        quote: "The backlit letters look incredible at night. <strong>We get walk-ins that say they saw the sign driving past</strong> — never had that before.",
      },
      {
        init: "AP",
        name: "Anita P.",
        biz: "Co-owner, Wildflower Kitchen — Portland, OR",
        quote: "The neon behind the bar is <strong>tagged on Instagram 400+ times since we opened.</strong> Best marketing spend we made.",
      },
    ],
    ctaH: "Signs That Work",
    ctaHem: "Before You Open.",
    ctaSub: "Share your logo and your space, exterior facade or interior wall. We mock it up in context before you spend a dollar.",
    ctaBtn: "Get Free Mockup",
  },
  health: {
    label: "Lightbox Signage / Cabinet Signs",
    h1: "Lightbox Signage",
    h1em: "Cabinet Signs",
    img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-04-50-00-PM.png?v=1790590062",
    alt: "Illuminated light box sign, lightbox sign and light box signs for business - quicksignage.com",
    desc: "Lightbox signage puts your logo on an evenly lit face that reads day and night. Choose wall mounted, double sided or custom sized cabinets, each custom lightbox sign fabricated in-house and shipped to all 50 states.",
    pills: ["Single or double sided", "Evenly lit faces", "Indoor & outdoor cabinets"],
    compareHead: "All 4 light box signs at a glance",
    compare: [
      {
        name: "Wall-Mounted Lightbox Sign",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$",
      },
      {
        name: "Custom lightbox",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$",
      },
      {
        name: "Double-Sided Lightbox",
        vis: 5,
        lighting: "lit",
        dur: 5,
        cost: "$$$",
      },
      {
        name: "Light box signage",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$",
      },
    ],
    whys: [
      {
        icon: "check",
        h: "Clean & Professional",
        s: "Finishes that match a clinical environment",
      },
      {
        icon: "layers",
        h: "Full System Pricing",
        s: "Discount for full building orders",
      },
      {
        icon: "repeat",
        h: "Updateable ID Panels",
        s: "Swap room names without replacing the sign",
      },
      {
        icon: "file",
        h: "Permit Drawings",
        s: "Ready for city and landlord approval",
      },
    ],
    sectionLabel: "4 Sign Types · Lightbox Signage / Cabinet Signs",
    sectionH: "Choose Your",
    sectionHem: "Lightbox Sign",
    sectionSub: "4 types of light box signs for business. Compare size, visibility and cost below.",
    installs: [
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_letters_LE_ml_resize_custom.jpg?v=1726056610",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_3__LE_auto_x2_1_optimized_2aab19f0-be86-4872-b5b0-004bc6f278dd.webp?v=1748083042",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Adhesive_Acrylic_Wall_Sign.webp?v=1726728662",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/Layer_100_63a178d6-f0c5-43a5-a030-c897a5e31825.png?v=1720418469",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/9c223b362d28070015feea9c3f4d2136_166bddae-60ef-4869-b0ec-f70e6663c7f4.jpg?v=1762509285",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/printed_sign_with_halo_lit_backboard_LE_ml_resize_custom.jpg?v=1726056610",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1a8bfc475f04e41dc4168ddc673f5e30.jpg?v=1773827971",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/metal_flat_cut.webp?v=1726053405",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Adhesive_Metal_Wall_Sign.jpg?v=1726728662",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/a41f50aee39a3c269c600156808215e7.jpg?v=1773827697",
    ],
    signs: [
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Chat-GPT-Image-Sep-25-2026-03-45-46-PM.png?v=1790672790",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Wall-Mounted Lightbox Sign",
        place: "interior",
        desc: "Single sided lightbox sign lit evenly from inside. A light box sign like this is among the most common lighted box signs and light box signs for business.",
        tags: ["Lightbox", "Wall-Mounted", "Single Sided"],
        alt: "Single sided lightbox sign, light box sign for business and lighted box signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Chat-GPT-Image-Sep-25-2026-03-54-09-PM.png?v=1790673094",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Custom lightbox",
        place: "both",
        desc: "A custom lightbox sign in any size, from a small custom light box to custom light box signs and custom outdoor lighted signs across a facade.",
        tags: ["Lightbox", "Custom", "Illuminated"],
        alt: "A custom lightbox sign, custom light box signs and custom outdoor lighted signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/round-light-box-sign-893941-1.webp?v=1790674885",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Double-Sided Lightbox",
        place: "exterior",
        desc: "Double sided light box signs readable from both directions, made as outdoor lightbox signs, indoor lightbox signs or light box signs outdoor.",
        tags: ["Double Sided", "Lightbox", "Illuminated"],
        alt: "Double sided light box sign, outdoor lightbox signs and light box signs for business - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/laroseli-s-Instagram-post-Magnolia-Press-Coffee-Co.jpg?v=1790590225",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Light box signage",
        place: "both",
        desc: "Single or double sided light box signage for walls and windows. Our lightbox signage makes a clear light box sign for business, indoors or as outdoor light box signs.",
        tags: ["Lightbox", "Single/Double Sided", "Illuminated"],
        alt: "Evenly lit light box signage, lightbox signage and outdoor light box signs - quicksignage.com",
      },
    ],
    testi: [
      {
        init: "KN",
        name: "Dr. Karen N.",
        biz: "NorthStar Family Medicine — Phoenix, AZ",
        quote: "Clean, professional, and the interior signs went up without a single hole in the drywall. <strong>Exactly what a medical office needs.</strong>",
      },
      {
        init: "RL",
        name: "Rachel L.",
        biz: "Ops Manager, Meridian Medical Park — Dallas, TX",
        quote: "Ordered room signs, directory, and the exterior letters together. <strong>Patient complaints about getting lost dropped to zero</strong> within a week.",
      },
    ],
    ctaH: "See Your",
    ctaHem: "Lightbox First.",
    ctaSub: "Share your logo and address. We'll mock up your lightbox sign on a photo of your actual building, free.",
    ctaBtn: "Get Free Mockup",
  },
  directional: {
    label: "Metal Backlit Signs / Halo Lit Signage",
    h1: "Metal Backlit Signs",
    h1em: "Halo Lit Signage",
    img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/download-22.jpg?v=1790590608",
    alt: "Metal backlit signs with halo lit channel letters, backlit signs for business - quicksignage.com",
    desc: "Halo lit metal letters are the standard for premium exterior branding, bright, dimensional and professional day or night. These are the backlit signs businesses order when they want their building to look established.",
    pills: ["UL-listed LED illumination", "Weather-rated metal fabrication", "Raceway & backboard mounting options"],
    compareHead: "All 6 backlit signs at a glance",
    compare: [
      {
        name: "Metal Backlit sign",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$$",
      },
      {
        name: "Outdoor backlit signs",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Custom Metal Backlit Sign on Raceway",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Halo lit Sign on Backboard",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Custom backlit sign",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "3D hollow cut sign",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
    ],
    whys: [
      {
        icon: "shield",
        h: "UL-Listed Components",
        s: "Meets US electrical codes",
      },
      {
        icon: "zap",
        h: "Even Halo Glow",
        s: "No hot spots or shadows",
      },
      {
        icon: "globe",
        h: "All 50 States",
        s: "Installation network nationwide",
      },
      {
        icon: "image",
        h: "Free Mockup on Building",
        s: "See it on your wall first",
      },
    ],
    sectionLabel: "6 Sign Types · Metal Backlit Signs / Halo Lit Signage",
    sectionH: "Choose Your",
    sectionHem: "Backlit Sign",
    sectionSub: "6 types of backlit metal signage for building facades, raceway or backboard mounted.",
    installs: [
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/Sign_Home_Banners_2_1.webp?v=1733208449",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/Sign_Home_Banners_1.png?v=1720681696",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/9c223b362d28070015feea9c3f4d2136_166bddae-60ef-4869-b0ec-f70e6663c7f4.jpg?v=1762509285",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Adhesive_Acrylic_Wall_Sign.webp?v=1726728662",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_flat_cut.webp?v=1726053397",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1a8bfc475f04e41dc4168ddc673f5e30.jpg?v=1773827971",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/a41f50aee39a3c269c600156808215e7.jpg?v=1773827697",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_3__LE_auto_x2_1_optimized_2aab19f0-be86-4872-b5b0-004bc6f278dd.webp?v=1748083042",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/b6d42cc645663d276ce14ed30556dca0.jpg?v=1773827847",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/2d85a2a2fc7666b85ef8c76c8d30591a.jpg?v=1774339718",
    ],
    signs: [
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-3-D-LED-Logo-Sign-for-Business-Edge-Lit-Illuminated-Company-Wall-Logo-Light-for-Office-Sho.jpg?v=1790590648",
        _imgLocked: true,
        badge: "badge-popular",
        badgeTxt: "Most Common",
        name: "Metal Backlit sign",
        place: "exterior",
        desc: "Halo lit letters, the standard backlit metal sign. Like all our backlit signs, it works for lettering or one backlit logo sign.",
        tags: ["3D", "Metal", "Backlit"],
        alt: "3D backlit metal sign with halo glow, backlit signs and backlit logo sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-Metal-Backlit-LED-Sign-3-D-Business-Signage-Storefront-Sign-Metal-Backlit-Sign-Sign-For-Of_0d4de8c9-1822-4b0f-966a-9b593fa0c4d4.jpg?v=1790590690",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Outdoor backlit signs",
        place: "exterior",
        desc: "Weather rated outdoor backlit signs for any facade, the backlit signage choice for backlit signs for business on busy roads.",
        tags: ["Backlit", "Exterior", "Illuminated"],
        alt: "Weather rated outdoor backlit signs, backlit signage and backlit signs for business - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Chat-GPT-Image-Sep-25-2026-04-24-40-PM.png?v=1790674397",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Custom Metal Backlit Sign on Raceway",
        place: "exterior",
        desc: "Backlit metal letters on a raceway with fewer wall holes. These back lit led signs can add a 3d backlit logo sign on the same raceway.",
        tags: ["Metal", "Backlit", "Raceway"],
        alt: "3D backlit metal letters on a raceway, back lit led signs and 3d backlit logo sign - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Chat-GPT-Image-Sep-25-2026-03-29-28-PM.png?v=1790674464",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Halo lit Sign on Backboard",
        place: "exterior",
        desc: "Backlit letters on a framed backboard, so one backlit sign carries your full backlit logo signage without extra wall work.",
        tags: ["Halo Lit", "Backboard", "Metal"],
        alt: "Halo lit metal letters on a backboard, backlit sign and backlit logo signage - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-04-35-04-PM.png?v=1790591845",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "Custom backlit sign",
        place: "exterior",
        desc: "Every custom backlit sign is built to your shape and size. We make custom backlit signs for single logos or full facades.",
        tags: ["Custom", "Backlit", "Exterior"],
        alt: "Made to order custom backlit sign, custom backlit signs and outdoor backlit signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/20171129-114703-1.webp?v=1790591718",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Exterior",
        name: "3D hollow cut sign",
        place: "exterior",
        desc: "Hollow cut letters that float in light, cut like our outdoor custom laser cut metal signs.",
        tags: ["Hollow Cut", "3D", "Illuminated"],
        alt: "3D hollow cut backlit sign, outdoor custom laser cut metal signs and laser cut signs - quicksignage.com",
      },
    ],
    testi: [
      {
        init: "MR",
        name: "Marcus R.",
        biz: "Owner, Riverfront Grill — Austin, TX",
        quote: "The halo-lit letters on our facade look <strong>incredible at night</strong>. The mockup matched the final product perfectly.",
      },
      {
        init: "DT",
        name: "David T.",
        biz: "Facilities Dir., Forge Fitness — Multiple Locations",
        quote: "We've done three locations now. <strong>Consistent quality every time</strong> on every backlit sign we've ordered.",
      },
    ],
    ctaH: "See It on Your",
    ctaHem: "Building First.",
    ctaSub: "Send your logo and address. We'll place your backlit sign on a photo of your actual building, free, in 2 hours.",
    ctaBtn: "Get Free Mockup on My Building",
  },
  interior: {
    label: "Indoor Signs / Interior Business Signage",
    h1: "Indoor Signs",
    h1em: "Interior Business Signage",
    img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/m-s-1.jpg?v=1790589113",
    alt: "Backlit indoor signs for business, indoor business signs and interior office signs - quicksignage.com",
    desc: "Every indoor sign type we make, from backlit interior signage and laser cut metal signs to lightbox cabinets and dimensional 3D letters. These interior business signs are fabricated in-house and shipped to all 50 states.",
    pills: ["Interior-grade materials", "No-drill adhesive option", "Offices, clinics, hotels"],
    compareHead: "All 8 indoor business signs at a glance",
    compare: [
      {
        name: "Indoor backlit Sign",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "2D Metal Sign",
        vis: 3,
        lighting: "nonlit",
        dur: 4,
        cost: "$",
      },
      {
        name: "Push-Through Sign",
        vis: 5,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "3D metal signs",
        vis: 4,
        lighting: "nonlit",
        dur: 5,
        cost: "$$",
      },
      {
        name: "3D halo lit with backboard",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
      {
        name: "Laser-Cut Metal Signage",
        vis: 3,
        lighting: "nonlit",
        dur: 4,
        cost: "$$",
      },
      {
        name: "Illuminated sign cabinet",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$",
      },
      {
        name: "Hollow Cut Sign",
        vis: 4,
        lighting: "lit",
        dur: 4,
        cost: "$$$",
      },
    ],
    whys: [
      {
        icon: "check",
        h: "No Drilling Option",
        s: "Adhesive mount available",
      },
      {
        icon: "clock",
        h: "2-Week Turnaround",
        s: "From approval to delivery",
      },
      {
        icon: "star",
        h: "Premium Finishes",
        s: "Brushed, gloss, matte",
      },
      {
        icon: "users",
        h: "Corporate & Medical",
        s: "Most common client types",
      },
    ],
    sectionLabel: "8 Sign Types · Indoor Signs / Interior Business Signage",
    sectionH: "Choose Your",
    sectionHem: "Indoor Sign",
    sectionSub: "8 types of interior signage for offices, lobbies and reception areas. Compare lighting and cost below.",
    installs: [
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_flat_cut.webp?v=1726053397",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/acrylic_letters_LE_ml_resize_custom.jpg?v=1726056610",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Adhesive_Acrylic_Wall_Sign.webp?v=1726728662",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/frontlit_and_backli_-_Copy.jpg?v=1762602617",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Adhesive_Metal_Wall_Sign.jpg?v=1726728662",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/1a8bfc475f04e41dc4168ddc673f5e30.jpg?v=1773827971",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/a41f50aee39a3c269c600156808215e7.jpg?v=1773827697",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/9c223b362d28070015feea9c3f4d2136_166bddae-60ef-4869-b0ec-f70e6663c7f4.jpg?v=1762509285",
      "https://cdn.shopify.com/s/files/1/0699/3553/0271/files/printed_sign.webp?v=1726726381",
      "https://cdn.shopify.com/s/files/1/0598/2096/6023/files/b6d42cc645663d276ce14ed30556dca0.jpg?v=1773827847",
    ],
    signs: [
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/download-82.jpg?v=1790589157",
        _imgLocked: true,
        badge: "badge-interior",
        badgeTxt: "Interior",
        name: "Indoor backlit Sign",
        place: "interior",
        desc: "Backlit metal letters for lobby walls, polished backlit interior signage used as indoor business signs and interior business signs.",
        tags: ["Metal", "Backlit", "Interior"],
        alt: "Indoor backlit metal letters, backlit interior signage and indoor business signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/download-88.jpg?v=1790589192",
        _imgLocked: true,
        badge: "badge-interior",
        badgeTxt: "Interior",
        name: "2D Metal Sign",
        place: "interior",
        desc: "Flat 5mm metal letters, simple interior signage for halls. Among our interior signs, the easiest way to add office interior signage.",
        tags: ["2D", "Metal", "5mm"],
        alt: "2D flat cut 5mm metal sign, interior signage and office interior signage - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Soulful-Essence-wall.jpg?v=1790589239",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Push-Through Sign",
        place: "interior",
        desc: "A push through acrylic sign where only letters glow, as an indoor business sign, a business sign indoor, or custom indoor signs for business.",
        tags: ["Push Through", "Lit", "Interior"],
        alt: "Indoor push through acrylic sign, indoor business sign and interior business signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/download-87.jpg?v=1790672359",
        _imgLocked: true,
        badge: "badge-interior",
        badgeTxt: "Interior",
        name: "3D metal signs",
        place: "interior",
        desc: "3D metal letters for interior office signs. These indoor office signs are the go-to for office signage indoor without lighting.",
        tags: ["3D", "Metal", "Interior"],
        alt: "Dimensional 3d metal signs, interior office signs and office signage indoor - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-03-23-24-PM.png?v=1790589417",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "3D halo lit with backboard",
        place: "interior",
        desc: "Backlit letters on a backboard for interior building signs in shared lobbies. We build custom interior building signs and interior business signage.",
        tags: ["Metal", "Backlit", "Backboard"],
        alt: "3D halo lit metal letters on a backboard, interior building signs and interior business signage - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/custom-lighted-metal-signs-led-backlit-laser-cut-business-signage-9145923-7770c562-7bcd-4a70-b7d3-8c.webp?v=1790589442",
        _imgLocked: true,
        badge: "badge-interior",
        badgeTxt: "Interior",
        name: "Laser-Cut Metal Signage",
        place: "interior",
        desc: "Precision laser cut metal signs with clean edges. Each laser cut metal sign or metal laser cut sign mounts flush or on standoffs, like all our laser cut signs.",
        tags: ["Laser Cut", "Precision", "Interior"],
        alt: "Precision laser cut metal signs, laser cut logo sign and custom laser cut signs - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/lightboxmain1.webp?v=1790589477",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Illuminated sign cabinet",
        place: "interior",
        desc: "An illuminated sign cabinet for reception walls, among the brightest indoor signs for business and slim interior signs for business.",
        tags: ["Lightbox", "Cabinet", "Illuminated"],
        alt: "An illuminated sign cabinet, indoor signs for business and interior signs for business - quicksignage.com",
      },
      {
        img: "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Inst-le-mdv.jpg?v=1790589595",
        _imgLocked: true,
        badge: "badge-lit",
        badgeTxt: "Interior",
        name: "Hollow Cut Sign",
        place: "interior",
        desc: "Hollow cut lit letters. A laser cut sign keeps every line of a custom laser cut logo or laser cut logo sign, and custom laser cut signs come in any size.",
        tags: ["Hollow Cut", "Lit", "Interior"],
        alt: "Hollow cut laser cut sign, custom laser cut logo and interior signs - quicksignage.com",
      },
    ],
    testi: [
      {
        init: "SL",
        name: "Sarah L.",
        biz: "Office Manager, Crestline Partners — Denver, CO",
        quote: "The 3D acrylic letters look <strong>seriously high-end</strong>. Our clients ask about them every single week.",
      },
      {
        init: "KN",
        name: "Dr. Karen N.",
        biz: "NorthStar Family Medicine — Phoenix, AZ",
        quote: "Clean, professional, and went up without a single hole in the drywall. <strong>Exactly what a medical office needs.</strong>",
      },
    ],
    ctaH: "Ready to Upgrade",
    ctaHem: "Your Reception?",
    ctaSub: "Share your logo and wall dimensions. We'll mock it up at scale so you know exactly how it looks before you commit.",
    ctaBtn: "Get Free Mockup",
  },
};

/* Hub card config — drives featured-categories.liquid */
window.QS.HUB_CARDS = [
  {
    key: "exterior",
    name: "Outdoor Signs / Exterior Signage",
    desc: "Weather ready outdoor business signs, exterior business signs, large outdoor signs for business and custom business signs outdoor.",
    alt: "Lit outdoor business signs, exterior business signs and large outdoor signs for business - quicksignage.com",
    slides: [
      "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-Backlit-Channel-Letter-Sign-3-D-Logo-Sign-Outdoor-Business-Wall-Sign-Illuminated-Storefront.jpg?v=1790587446",
      "https://i.ibb.co/CsD0v1yV/Exterior-2.jpg",
      "https://i.ibb.co/nMBvFXrL/Exterior-3.jpg",
    ],
    interval: 6000,
  },
  {
    key: "storefront",
    name: "Storefront Signs / Outdoor Building Signage",
    desc: "Channel letters, lightboxes and 3D letters made as storefront signs, storefront signage and store front signs for business.",
    alt: "Illuminated storefront signs, storefront signage and store front signs for business - quicksignage.com",
    slides: [
      "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-3-D-Metal-Backlit-Business-Logo-Sign-Illuminated-Storefront-Signage-Laser-Cut-Stainless-Stee.jpg?v=1790588353",
      "https://i.ibb.co/mCmWjhFS/Storefronts-1.jpg",
      "https://i.ibb.co/jPLvTFk4/Storefronts-2.jpg",
      "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/LED_Lit_Channel_Letters_Logo.jpg?v=1790668918",
    ],
    interval: 6000,
  },
  {
    key: "interior",
    name: "Indoor Signs / Interior Business Signage",
    desc: "Backlit, laser cut and 3D pieces made as indoor business signs, interior office signs and indoor signs for business.",
    alt: "Backlit indoor signs for business, indoor business signs and interior office signs - quicksignage.com",
    slides: [
      "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/m-s-1.jpg?v=1790589113",
      "https://i.ibb.co/h1tDfqnQ/download-45.jpg",
      "https://i.ibb.co/Txr0Nh8w/download-47.jpg",
      "https://i.ibb.co/tMp62LdR/download-48.jpg",
      "https://i.ibb.co/DHp3h8BX/download-49.jpg",
      "https://i.ibb.co/RpNVqX6S/Euro-Tunnel-LED-Lighting-LSE-Lighting.jpg",
      "https://i.ibb.co/RT8LG7Q5/Custom-Acrylic-3-D-Business-Sign-Glossy-Black-Wall-Letters-1.jpg",
      "https://i.ibb.co/ycM5VVXy/Letreros-en-Acr-lico-con-Retroiluminaci-n-LED-1.jpg",
      "https://i.ibb.co/b5DLXR9p/m-s.jpg",
      "https://i.ibb.co/Cs3kxkdj/Custom-Illuminated-Metal-Channel-Letter-Sign-Backlit-Business-Logo.jpg",
      "https://i.ibb.co/zwzGthT/Custom-Metal-Backlit-Sign-Personalized-Signage-Office-Logo-for-Wall-illuminated-Signage-Comp.jpg",
    ],
    interval: 5500,
  },
  {
    key: "restaurant",
    name: "Corporate & Restaurant Signs / Commercial Signage",
    desc: "Backlit letters, lightboxes and 3D letters for corporate signage, commercial signage and every commercial sign you need.",
    alt: "Backlit corporate signage, commercial signage and commercial business signs - quicksignage.com",
    slides: [
      "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-04-45-18-PM.png?v=1790589637",
      "https://i.ibb.co/j9kxrRSh/restraunts-and-hotels-jpg-1.jpg",
      "https://i.ibb.co/RTnBwXF2/restraunts-and-hotels-jpg-2.jpg",
      "https://i.ibb.co/Wvgxcn93/restraunts-and-hotels-jpg-3.jpg",
    ],
    interval: 6000,
  },
  {
    key: "health",
    name: "Lightbox Signage / Cabinet Signs",
    desc: "Wall mounted, double sided and custom cabinets. Every lightbox sign and light box sign is lit evenly day and night.",
    alt: "Illuminated light box sign, lightbox sign and light box signs for business - quicksignage.com",
    slides: [
      "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Chat-GPT-Image-Sep-25-2026-04-50-00-PM.png?v=1790590062",
      "https://i.ibb.co/KphmhVCC/health-and-pharma-1.jpg",
      "https://i.ibb.co/5hGHCDrk/health-and-pharma-2.jpg",
      "https://i.ibb.co/fdkR5pfM/health-and-pharma-3.jpg",
      "https://i.ibb.co/Mk49jJkz/health-and-pharma-4.jpg",
    ],
    interval: 5800,
  },
  {
    key: "salon",
    name: "Face Lit Signage / Front Lit Signs",
    desc: "Bright face lit letters, front lit channel letters and 3d acrylic signs, built as lighted business signs.",
    alt: "Bright face lit letters, front lit channel letters and lighted business signs - quicksignage.com",
    slides: [
      "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/Custom-Frontlit-Channel-Letters-LED-Storefront-Sign-for-Restaurant-Cafe-Bakery-Retail.jpg?v=1790590296",
      "https://i.ibb.co/DZsGJmL/Salon-spa-and-gyms-1.jpg",
      "https://i.ibb.co/BVZdNf1X/Salon-spa-and-gyms-2.jpg",
      "https://i.ibb.co/CsXCbZrK/Salon-spa-and-gyms-3.jpg",
    ],
    interval: 6000,
  },
  {
    key: "directional",
    name: "Metal Backlit Signs / Halo Lit Signage",
    desc: "Halo lit metal letters and backlit signs that glow at night. Every custom backlit sign is built to your logo.",
    alt: "Metal backlit signs with halo lit channel letters, backlit signs for business - quicksignage.com",
    slides: [
      "https://cdn.shopify.com/s/files/1/0883/9508/8167/files/download-22.jpg?v=1790590608",
      "https://i.ibb.co/SXNv5mwS/directional-and-monument-1.jpg",
      "https://i.ibb.co/TDzDWHhY/directional-and-monument-2.jpg",
      "https://i.ibb.co/rKrBRKKc/directional-and-monument-3.jpg",
    ],
    interval: 6000,
  },
  {
    key: "lobby",
    name: "Illuminated Channel Letters / Raceway Signage",
    desc: "Front lit, backlit and halo lit channel letters on raceways, plus illuminated signs built to your logo.",
    alt: "Bright illuminated channel letters on a raceway, channel letters signs and halo lit channel letters - quicksignage.com",
    slides: [
      "https://cdn.shopify.com/s/files/1/0598/7391/9062/files/Chat-GPT-Image-Sep-25-2026-04-57-24-PM.png?v=1790756268",
      "https://i.ibb.co/6RbfyDF0/lobby-and-reception.jpg",
    ],
    interval: 6800,
  },
];

/* Category URL helpers — URLs use the readable main name (?category=corporate-restaurant-signs),
   legacy keys (?category=restaurant) still resolve. */
window.QS.catMainName = function (card) {
  return String((card && card.name) || "").split(" / ")[0].trim();
};
window.QS.catSlug = function (card) {
  return window.QS.catMainName(card)
    .toLowerCase()
    .replace(/&/g, " ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};
window.QS.catUrl = function (card) {
  return "/pages/collections?category=" + encodeURIComponent(window.QS.catSlug(card));
};
/* URL param (slug or legacy key) → CATS key, or null */
window.QS.resolveCatKey = function (param) {
  if (!param) return null;
  var cats = window.QS.CATS || {};
  var p = String(param).toLowerCase();
  var cards = window.QS.HUB_CARDS || [];
  for (var i = 0; i < cards.length; i++) {
    if (window.QS.catSlug(cards[i]) === p && cats[cards[i].key]) return cards[i].key;
  }
  return cats[param] ? param : null;
};
/* Main category name for a CATS key, e.g. "Corporate & Restaurant Signs" */
window.QS.catNameForKey = function (key) {
  var cards = window.QS.HUB_CARDS || [];
  for (var i = 0; i < cards.length; i++) {
    if (cards[i].key === key) return window.QS.catMainName(cards[i]);
  }
  return "";
};

/* ── Helpers ── */
function esc(t) {
  return String(t)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/"/g, "&quot;");
}
function arrowR() {
  return '<svg viewBox="0 0 24 24" style="width:12px;height:12px;stroke:currentColor;stroke-width:2.5;fill:none;stroke-linecap:round;stroke-linejoin:round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
}

/* ── Per-sign image galleries (from sign-types-updates.html) — each sign type shows ONLY its own photos ── */
const GALLERY_2D_ACRYLIC = [
  "https://i.ibb.co/cKrDxh0W/2d-acrylic-image-1.webp",
  "https://i.ibb.co/QF75Gqc2/2d-acrylic-image-2.webp",
  "https://i.ibb.co/rRz56gjV/2d-acrylic-image-3.webp",
];
const GALLERY_2D_BLADE = [
  "https://i.ibb.co/KtbtvFN/2d-blade-sign-image-1.jpg",
  "https://i.ibb.co/sdb7XW7V/2d-blade-sign-image-2.jpg",
  "https://i.ibb.co/k2GvNCKW/2d-blade-sign-image-3.jpg",
  "https://i.ibb.co/Dg6VSGFn/2d-blade-sign-image-4.jpg",
  "https://i.ibb.co/Fk6mSBN6/2d-blade-sign-image-5.jpg",
  "https://i.ibb.co/GjKFNRz/2d-blade-sign-image-6.jpg",
  "https://i.ibb.co/HfRph5Yf/2d-blade-sign-image-7.jpg",
  "https://i.ibb.co/07TMQzZ/2d-blade-sign-image-8.png",
  "https://i.ibb.co/DDf3bLgN/2d-blade-sign-image-9.jpg",
  "https://i.ibb.co/PZsmgQg2/2d-blade-sign-image-10.png",
  "https://i.ibb.co/m5x5YBDN/2d-blade-sign-image-11.jpg",
  "https://i.ibb.co/PHhwrVs/2d-blade-sign-image-12.jpg",
];
const GALLERY_2D_METAL_5MM = [
  "https://i.ibb.co/JRHCJxZ9/2d-metal-5mm-image-1.jpg",
  "https://i.ibb.co/JFC3PgnK/2d-metal-5mm-image-2.jpg",
  "https://i.ibb.co/HTDYwm8C/2d-metal-5mm-image-3.jpg",
  "https://i.ibb.co/Kj7VsRbp/2d-metal-5mm-image-4.jpg",
  "https://i.ibb.co/MDXDmYL8/image-2025-09-05-T162604-043-1.png",
  "https://i.ibb.co/PsGxtf25/2d-metal-5mm-image-6.png",
  "https://i.ibb.co/MkVz3Cdk/2d-metal-5mm-image-7.jpg",
  "https://i.ibb.co/LbT6w71/2d-metal-5mm-image-8.jpg",
  "https://i.ibb.co/qFCKPfsR/2d-metal-5mm-image-9.jpg",
  "https://i.ibb.co/hJNbyPCd/2d-metal-5mm-image-10.jpg",
  "https://i.ibb.co/TQLN3Hx/2d-metal-5mm-image-11.jpg",
];
const GALLERY_3D_ACRYLIC = [
  "https://i.ibb.co/rRF1nW17/3d-acrylic-image-1.jpg",
  "https://i.ibb.co/fVNZHcxm/3d-acrylic-image-2.jpg",
  "https://i.ibb.co/B5VQStsW/3d-acrylic-image-3.jpg",
  "https://i.ibb.co/hF61JpWJ/3d-acrylic-image-4.jpg",
  "https://i.ibb.co/LX4W3CCF/3d-acrylic-image-5.jpg",
  "https://i.ibb.co/0jVzgBg0/3d-acrylic-image-6.jpg",
  "https://i.ibb.co/spdzmWNq/3d-acrylic-image-7.jpg",
  "https://i.ibb.co/prnQC8Hh/3d-acrylic-image-8.jpg",
  "https://i.ibb.co/7wkQwhX/3d-acrylic-image-9.jpg",
  "https://i.ibb.co/Rk0nGr2z/3d-acrylic-image-10.jpg",
  "https://i.ibb.co/8LtG0dT2/3d-acrylic-image-11.jpg",
  "https://i.ibb.co/n87DDLPZ/3d-acrylic-image-12.jpg",
  "https://i.ibb.co/d0VL1yPf/3d-acrylic-image-13.jpg",
  "https://i.ibb.co/j9qPdbg3/3d-acrylic-image-14.jpg",
  "https://i.ibb.co/JWND7QCP/3d-acrylic-image-15.jpg",
];
const GALLERY_ACRYLIC_FRONTLIT = [
  "https://i.ibb.co/27R8x8DX/3d-acrylic-frontlit-image-1-1.png",
  "https://i.ibb.co/d4ytmbkQ/3d-acrylic-frontlit-image-1-1.webp",
  "https://i.ibb.co/gMwQsKDK/3d-acrylic-frontlit-image-1-2.jpg",
  "https://i.ibb.co/hFXH3c1W/3d-acrylic-frontlit-image-1-2.png",
  "https://i.ibb.co/1Yh0S4My/3d-acrylic-frontlit-image-1-2.webp",
  "https://i.ibb.co/pjDJ0KbL/3d-acrylic-frontlit-image-1-3.jpg",
  "https://i.ibb.co/ZzdQ0Tx7/3d-acrylic-frontlit-image-1-3.webp",
  "https://i.ibb.co/C3yydL9b/3d-acrylic-frontlit-image-1-4.jpg",
  "https://i.ibb.co/7JtJktT1/f90a27855a35609cbfddc596a4eaf51f.jpg",
  "https://i.ibb.co/FqK3Y0dM/3d-acrylic-frontlit-image-1-6.jpg",
  "https://i.ibb.co/N6K33S7Q/3d-acrylic-frontlit-image-1-7.jpg",
  "https://i.ibb.co/WW5zd4c3/3d-acrylic-frontlit-image-1-8.jpg",
  "https://i.ibb.co/0jg0Src7/3d-acrylic-frontlit-image-1-9.jpg",
  "https://i.ibb.co/CXYxRLB/Michael-Hsu-Office-of-Architecture-Howler-Brothers-Hacienda.jpg",
  "https://i.ibb.co/m55Pzd4C/3d-acrylic-frontlit-image-1-11.jpg",
  "https://i.ibb.co/8Dt2Yjq1/3d-acrylic-frontlit-image-1-1.avif",
  "https://i.ibb.co/whzSfHLb/3d-acrylic-frontlit-image-1-1.jpg",
];
const GALLERY_3D_BLADE = [
  "https://i.ibb.co/yBP4T6Qn/3-D-blade-sign-1.jpg",
  "https://i.ibb.co/KxwFX2S9/3-D-blade-sign-2.jpg",
  "https://i.ibb.co/DHMJV0sM/3-D-blade-sign-3.jpg",
  "https://i.ibb.co/sJwnjfpJ/3-D-blade-sign-4.jpg",
  "https://i.ibb.co/5xT6bHrN/3-D-blade-sign-5.jpg",
  "https://i.ibb.co/mrn3RvDW/3-D-blade-sign-6.jpg",
  "https://i.ibb.co/DP0XmH96/3-D-blade-sign-7.jpg",
];
const GALLERY_3D_METAL_BACKLIT = [
  "https://i.ibb.co/QFxd6K3Y/IMG-1228.jpg",
  "https://i.ibb.co/pjLSBCNG/3d-metal-backlit-1.jpg",
  "https://i.ibb.co/mCg3nNM9/image-45-1-3.png",
  "https://i.ibb.co/wZJPVMTC/IMG-1229.jpg",
  "https://i.ibb.co/ymwCTPF0/3d-metal-backlit-2.jpg",
  "https://i.ibb.co/27YHMvmN/IMG-1230.jpg",
  "https://i.ibb.co/nMmsqw9d/3d-metal-backlit-3.jpg",
  "https://i.ibb.co/nqKdGsfQ/3d-metal-backlit-4.jpg",
  "https://i.ibb.co/KjdYLj5x/3d-metal-backlit-4.jpg",
  "https://i.ibb.co/20F4fF2W/3d-metal-backlit-5.jpg",
  "https://i.ibb.co/wrLr5GqL/3d-metal-backlit-5.jpg",
  "https://i.ibb.co/q3bGb12d/3d-metal-backlit-6.jpg",
  "https://i.ibb.co/p6PjWp0t/3d-metal-backlit-6.jpg",
  "https://i.ibb.co/j9mF2kv2/3d-metal-backlit-7.jpg",
  "https://i.ibb.co/gMxkWMnt/3d-metal-backlit-7.jpg",
  "https://i.ibb.co/6c3cqMjv/3d-metal-backlit-8.jpg",
  "https://i.ibb.co/Kc7sKKbY/3d-metal-backlit-8.jpg",
  "https://i.ibb.co/6kjvmj8/3d-metal-backlit-9.jpg",
  "https://i.ibb.co/BHwPRZLj/3d-metal-backlit-9.jpg",
  "https://i.ibb.co/Z6zR7Xz6/3d-metal-backlit-10.jpg",
  "https://i.ibb.co/7Jv3Wt6k/3d-metal-backlit-10.jpg",
  "https://i.ibb.co/RGrGZDvB/3d-metal-backlit-11.jpg",
  "https://i.ibb.co/QFC2byVD/3d-metal-backlit-11.jpg",
  "https://i.ibb.co/Z1L3dBRr/3d-metal-backlit-12.jpg",
  "https://i.ibb.co/JjH7RYXV/3d-metal-backlit-12.jpg",
  "https://i.ibb.co/fzs9Qb0m/3d-metal-backlit-13.jpg",
  "https://i.ibb.co/04YzxMM/il-fullxfull-3364115706-s1fg.jpg",
  "https://i.ibb.co/604DDQqy/3d-metal-backlit-14.jpg",
  "https://i.ibb.co/Q7bdSNxW/3d-metal-backlit-14.jpg",
  "https://i.ibb.co/9HwcwDMD/3d-metal-backlit-15.jpg",
  "https://i.ibb.co/XrqJnGWV/3d-metal-backlit-16.jpg",
  "https://i.ibb.co/f3Yf3KG/3d-metal-backlit-17.jpg",
  "https://i.ibb.co/d4Zn3w9n/3d-metal-backlit-18.jpg",
  "https://i.ibb.co/vCFtCxc3/3d-metal-backlit-19.jpg",
  "https://i.ibb.co/b5wqKCHN/3d-metal-backlit-20.jpg",
  "https://i.ibb.co/B2rwzK79/3d-metal-backlit-21.jpg",
  "https://i.ibb.co/yFcVNCrW/3d-metal-backlit-22.jpg",
  "https://i.ibb.co/hRpKjX7P/3d-metal-backlit-23.jpg",
  "https://i.ibb.co/ksd9Gm06/3d-metal-backlit-24.jpg",
  "https://i.ibb.co/VYx0CYPz/3d-metal-backlit-25.jpg",
  "https://i.ibb.co/hxhz9z7C/3d-metal-backlit-26.jpg",
  "https://i.ibb.co/HLcR29YX/3d-metal-backlit-27.jpg",
  "https://i.ibb.co/1t5wW4SK/3d-metal-backlit-29.jpg",
  "https://i.ibb.co/nsKDRtdW/3d-metal-backlit-30.jpg",
  "https://i.ibb.co/QF5rqKbP/3d-metal-backlit-31.jpg",
  "https://i.ibb.co/G447Bm70/3d-metal-backlit-32.jpg",
  "https://i.ibb.co/Kzz1s8pG/3d-metal-backlit-33.jpg",
  "https://i.ibb.co/HD3sMFMx/3d-metal-backlit-34.jpg",
  "https://i.ibb.co/tMBjpNKJ/3d-metal-backlit-35.jpg",
  "https://i.ibb.co/Mk0N1pVQ/3d-metal-backlit-36.jpg",
  "https://i.ibb.co/6dgB58T/3d-metal-backlit-37.jpg",
  "https://i.ibb.co/jv2BLKNW/3d-metal-backlit-38.jpg",
  "https://i.ibb.co/XfqMBKyw/3d-metal-backlit-39.jpg",
  "https://i.ibb.co/yFVSQJfY/3d-metal-backlit-40.jpg",
  "https://i.ibb.co/4ZSBL9Z7/3d-metal-backlit-41.jpg",
  "https://i.ibb.co/kVTZMfjj/3d-metal-backlit-42.jpg",
  "https://i.ibb.co/SDQwT2BM/5318375ade152f04be94302581991bd2.jpg",
  "https://i.ibb.co/S4xbJsCM/3d-metal-backlit-44.jpg",
  "https://i.ibb.co/dsVzB3MM/3d-metal-backlit-45.jpg",
  "https://i.ibb.co/8g57xCnN/3d-metal-backlit-46.jpg",
  "https://i.ibb.co/JWBxd1gR/3d-metal-backlit-47.jpg",
  "https://i.ibb.co/pBdr2X2W/3d-metal-backlit-48.jpg",
  "https://i.ibb.co/6cR23c2Q/3d-metal-backlit-49.jpg",
  "https://i.ibb.co/gL6qDHJZ/3d-metal-backlit-50.jpg",
  "https://i.ibb.co/Pzf1ML41/3d-metal-backlit-51.jpg",
  "https://i.ibb.co/9HKT1Y3C/3d-metal-backlit-52.jpg",
  "https://i.ibb.co/tw2cFdpR/3d-metal-backlit-53.jpg",
  "https://i.ibb.co/2YkSJ4BY/3d-metal-backlit-54.jpg",
  "https://i.ibb.co/qFm6W27j/3d-metal-backlit-55.jpg",
  "https://i.ibb.co/tPXMNwSh/3d-metal-backlit-56.jpg",
  "https://i.ibb.co/h1Ykst2D/3d-metal-backlit-57.jpg",
  "https://i.ibb.co/21dRVnLb/3d-metal-backlit-58.jpg",
  "https://i.ibb.co/1t9RmqhG/3d-metal-backlit-59.jpg",
  "https://i.ibb.co/twS8MgXm/3d-metal-backlit-60.jpg",
  "https://i.ibb.co/zHj3jXDn/3d-metal-backlit-61.jpg",
  "https://i.ibb.co/gZB60Zh0/3d-metal-backlit-62.jpg",
  "https://i.ibb.co/F9vDDxt/3d-metal-backlit-63.jpg",
  "https://i.ibb.co/nshbjfGR/3d-metal-backlit-64.jpg",
  "https://i.ibb.co/0Vp9fT4p/3d-metal-backlit-65.jpg",
  "https://i.ibb.co/0j2MC0d8/3d-metal-backlit-66.jpg",
  "https://i.ibb.co/zghyZTZ/3d-metal-backlit-67.jpg",
  "https://i.ibb.co/pvSF1Cnd/3d-metal-backlit-68.jpg",
  "https://i.ibb.co/k2WFxd2v/3d-metal-backlit-69.jpg",
  "https://i.ibb.co/VppDW2Ft/3d-metal-backlit-70.jpg",
  "https://i.ibb.co/gsDqXd9/3d-metal-backlit-71.jpg",
  "https://i.ibb.co/zVpbsdHK/3d-metal-backlit-72.jpg",
  "https://i.ibb.co/Q7hD49zV/3d-metal-backlit-73.jpg",
  "https://i.ibb.co/Zzz40Xww/3d-metal-backlit-74.jpg",
  "https://i.ibb.co/bgCG6m9C/3d-metal-backlit-75.jpg",
  "https://i.ibb.co/Z1dNL0k8/3d-metal-backlit-76.jpg",
];
const GALLERY_3D_METAL_NONLIT = [
  "https://i.ibb.co/fLZ1FSz/3d-metal-nonlit-1.jpg",
  "https://i.ibb.co/gY00w01/3d-metal-nonlit-2.jpg",
  "https://i.ibb.co/Z6kGhHTf/3d-metal-nonlit-2.jpg",
  "https://i.ibb.co/C5TD1pmX/3d-metal-nonlit-3.jpg",
  "https://i.ibb.co/fzDjRh7m/3d-metal-nonlit-3.jpg",
  "https://i.ibb.co/jkZCwZBH/3d-metal-nonlit-4.jpg",
  "https://i.ibb.co/nNR7pNYN/3d-metal-nonlit-4.jpg",
  "https://i.ibb.co/vxBh8R5B/3d-metal-nonlit-5.jpg",
  "https://i.ibb.co/prBLzKCK/3d-metal-nonlit-5.jpg",
  "https://i.ibb.co/PvgcTbF8/3d-metal-nonlit-6.jpg",
  "https://i.ibb.co/Df4V4dCw/3d-metal-nonlit-6.jpg",
  "https://i.ibb.co/F4ySmc63/3d-metal-nonlit-7.jpg",
  "https://i.ibb.co/k6WWXwRV/3d-metal-nonlit-8.jpg",
  "https://i.ibb.co/8D7y0qkp/3d-metal-nonlit-9.jpg",
  "https://i.ibb.co/ksBm9mvq/3d-metal-nonlit-10.jpg",
  "https://i.ibb.co/rRhghfhJ/3d-metal-nonlit-1.jpg",
];
const GALLERY_LIGHTBOX = [
  "https://i.ibb.co/kVr1kG25/Lightbox-1.png",
  "https://i.ibb.co/LXFbW1Fs/Lightbox-1.webp",
  "https://i.ibb.co/FkktmY25/Lightbox-2.jpg",
  "https://i.ibb.co/n8cS0bXL/Lightbox-2.webp",
  "https://i.ibb.co/Fkz7g6L5/Lightbox-3.jpg",
  "https://i.ibb.co/x8LxNLWb/Lightbox-4.jpg",
  "https://i.ibb.co/SDJFYxVL/Lightbox-5.jpg",
  "https://i.ibb.co/hQkLXNH/Lightbox-6.jpg",
  "https://i.ibb.co/FbD49P8M/Lightbox-1.jpg",
  "https://i.ibb.co/93pQHDGX/Lightbox-1.jpg",
];
const GALLERY_NEON = [
  "https://i.ibb.co/d0x1CYvz/NEON-1.png",
  "https://i.ibb.co/nskq43zT/NEON-2.png",
  "https://i.ibb.co/s93fQ0Df/NEON-3.png",
];
const GALLERY_UV_ACRYLIC = [
  "https://i.ibb.co/1fX1Jpsn/uv-acrylic-1.jpg",
  "https://i.ibb.co/BHB0yHby/uv-acrylic-1.jpg",
  "https://i.ibb.co/wFhJk1J7/uv-acrylic-2.jpg",
  "https://i.ibb.co/LXmgBKHd/uv-acrylic-2.jpg",
  "https://i.ibb.co/Xfdhh79j/uv-acrylic-3.jpg",
  "https://i.ibb.co/M5VLKQ0t/uv-acrylic-3.jpg",
  "https://i.ibb.co/Xr9pjscJ/uv-acrylic-4.jpg",
  "https://i.ibb.co/RkSNd6vd/uv-acrylic-5.jpg",
  "https://i.ibb.co/2930Dgc/uv-acrylic-6.jpg",
];
const GALLERY_UV_NEON_ACRYLIC = [
  "https://i.ibb.co/hFCfRXYg/uv-neon-acrylic-1.jpg",
  "https://i.ibb.co/QjC8BVYK/uv-neon-acrylic-1.jpg",
  "https://i.ibb.co/Jj9Mh7Mn/uv-neon-acrylic-2.jpg",
  "https://i.ibb.co/PGjz7jvQ/uv-neon-acrylic-2.jpg",
  "https://i.ibb.co/k2q7KbXF/uv-neon-acrylic-3.jpg",
  "https://i.ibb.co/QvMLFxbM/uv-neon-acrylic-3.jpg",
  "https://i.ibb.co/zHBBSv3c/uv-neon-acrylic-4.jpg",
  "https://i.ibb.co/5hhQCHYc/uv-neon-acrylic-4.jpg",
  "https://i.ibb.co/9kX6gybq/uv-neon-acrylic-5.jpg",
  "https://i.ibb.co/ycQ6PRH0/uv-neon-acrylic-5.jpg",
  "https://i.ibb.co/wZbm7GbB/uv-neon-acrylic-6.jpg",
];
const GALLERY_HOLLOW_CUT = [
  "https://i.ibb.co/L7Lqgjh/Hollow-cut-1.webp",
  "https://i.ibb.co/7dW93LSK/Hollow-cut-2.webp",
  "https://i.ibb.co/M59VNj4r/Hollow-cut-1.png",
];
const GALLERY_PUSH_THRU = [
  "https://i.ibb.co/mCRFxmHW/Push-Thru.png",
  "https://i.ibb.co/k2qZ774p/Push-Thru-png.png",
];
const GALLERY_OPEN_FACE_NEON = ["https://i.ibb.co/Kcxh3wsG/open-face-neon.png"];
const GALLERY_ACRYLIC_DOUBLE_LIT = ["https://i.ibb.co/xtVhZYBm/Chat-GPT-Image-Mar-19-2026-12-52-56-PM-1.png"];
const GALLERY_YARD_SIGN = ["https://i.ibb.co/WN4kKWLb/yard-sign.jpg"];

const SIGN_IMAGE_GALLERIES = {
  metalbacklit: GALLERY_3D_METAL_BACKLIT,
  metalbacklitletters: GALLERY_3D_METAL_BACKLIT,
  "3dmetalbacklit": GALLERY_3D_METAL_BACKLIT,
  metalbacklitwithraceway: GALLERY_3D_METAL_BACKLIT,
  metalbacklitwithbackboard: GALLERY_3D_METAL_BACKLIT,
  outdoorbacklitsigns: GALLERY_3D_METAL_BACKLIT,
  metalbacklitlettersonbackboardraceway: GALLERY_3D_METAL_BACKLIT,
  "3dmetalbacklithalolitletters": GALLERY_3D_METAL_BACKLIT,
  "3dbacklitonbackboardraceway": GALLERY_3D_METAL_BACKLIT,
  "2d3dmetalwithboard": [...GALLERY_2D_METAL_5MM, ...GALLERY_3D_METAL_NONLIT],
  acrylicfrontlit: GALLERY_ACRYLIC_FRONTLIT,
  acrylicfrontlitletters: GALLERY_ACRYLIC_FRONTLIT,
  acrylicfrontlitwithraceway: GALLERY_ACRYLIC_FRONTLIT,
  acrylicfrontlitwithbackboard: GALLERY_ACRYLIC_FRONTLIT,
  frontlitletters: GALLERY_ACRYLIC_FRONTLIT,
  frontlitchannelletters: GALLERY_ACRYLIC_FRONTLIT,
  "2dmetalsign": GALLERY_2D_METAL_5MM,
  "2dmetal": GALLERY_2D_METAL_5MM,
  "2dmetalnonlit": GALLERY_2D_METAL_5MM,
  "2dmetal5mmflatcut": GALLERY_2D_METAL_5MM,
  "2mmflatcutsign": GALLERY_2D_METAL_5MM,
  flatcutletters2mmmetal: GALLERY_2D_METAL_5MM,
  lasercutsign: GALLERY_2D_METAL_5MM,
  pushthrusign: GALLERY_PUSH_THRU,
  pushthroughsign: GALLERY_PUSH_THRU,
  lightboxdoublesidedsinglesided: GALLERY_LIGHTBOX,
  lightboxsinglesided: GALLERY_LIGHTBOX,
  lightboxdoublesided: GALLERY_LIGHTBOX,
  lightboxsign: GALLERY_LIGHTBOX,
  wallmountedlightbox: GALLERY_LIGHTBOX,
  "3dbladesign": GALLERY_3D_BLADE,
  "2dbladesign": GALLERY_2D_BLADE,
  "2dflatbladesign": GALLERY_2D_BLADE,
  hollowcutsign: GALLERY_HOLLOW_CUT,
  openneonfacesign: GALLERY_OPEN_FACE_NEON,
  ledflexneonsign: GALLERY_NEON,
  ledneonsign: GALLERY_NEON,
  "3dmetalnonlit": GALLERY_3D_METAL_NONLIT,
  customfabricated3dsign: GALLERY_3D_METAL_NONLIT,
  "3dacrylicnonlit": GALLERY_3D_ACRYLIC,
  "2dacrylic10mm": GALLERY_2D_ACRYLIC,
  uvacrylicpanel: GALLERY_UV_ACRYLIC,
  uvacrylicneonpanel: GALLERY_UV_NEON_ACRYLIC,
  acrylicbacklitpanel: GALLERY_ACRYLIC_DOUBLE_LIT,
  ledstorefrontsigns: GALLERY_ACRYLIC_DOUBLE_LIT,
  yardsign: GALLERY_YARD_SIGN,
};

function signGalleryKey(name) {
  return String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}
function galleryForSign(name) {
  return SIGN_IMAGE_GALLERIES[signGalleryKey(name)] || null;
}
function uniqueImages(list) {
  return [...new Set((list || []).filter(Boolean))];
}
function applyProductImagesToCats() {
  Object.entries(window.QS.CATS).forEach(([catId, c]) => {
    const categoryImages = [];
    (c.signs || []).forEach((s) => {
      const gallery = galleryForSign(s.name);
      if (!gallery || !gallery.length) return;
      s.gallery = uniqueImages(s._imgLocked ? [s.img].concat(gallery) : gallery);
      // Only auto-assign img if the sign didn't already have a curated one
      if (!s._imgLocked) s.img = s.gallery[0];
      categoryImages.push(...s.gallery.slice(0, 3));
    });
    const merged = uniqueImages(
      categoryImages.length ? categoryImages : c.installs || [],
    );
    if (merged.length) {
      c.installs = merged.slice(0, 24);
      // Do NOT overwrite c.img — preserve the curated hero image
      // c.img=merged[0];
    }
  });
}
applyProductImagesToCats();
